/**
 * Regular expression patterns used for form validation
 */

export const VALIDATION_PATTERNS = {
  /**
   * Validates numeric values with optional decimal places (up to 2 decimal places)
   * Examples: 123, 123.45, 0.99
   */
  NUMERIC: /^\d+(\.\d{1,2})?$/,

  /**
   * Validates Salesforce Opportunity ID format (exactly 18 alphanumeric characters)
   * Example: 006XX000004TmiQYAS
   */
  SF_OPPORTUNITY_ID: /^[a-zA-Z0-9]{18}$/,

  /**
   * Validates RO (Release Order) format
   * Allows alphanumeric characters, hyphens, and underscores (1-50 characters)
   * Examples: RO-123, RO_456, ABC123-XYZ
   */
  RO_FORMAT: /^[a-zA-Z0-9\-_]{1,50}$/,

  /**
   * Validates percentage values with optional decimal places (up to 2 decimal places)
   * Examples: 0, 25, 99.99, 100, 150.75, 200
   */
  PERCENTAGE: /^\d+(\.\d{1,2})?$/,
} as const;
